const classes = {
  card: {
    maxWidth: '500px',
  },
  title: {
    fontSize: 32,
    fontWeight: 700,
    textAlign: 'center',
  },
  description: {
    color: 'common.grey800',
    fontSize: 14,
    lineHeight: 1.6,
    textAlign: 'center',
  },
  consentPrompt: {
    color: 'common.grey800',
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 2,
    textAlign: 'center',
  },
  detailsContainer: {
    backgroundColor: 'common.lightBackgroundColor',
    borderRadius: 2,
    padding: 2,
  },
  detailRow: {
    display: 'flex',
    gap: 1,
    paddingY: 0.5,
  },
  detailLabel: {
    color: 'common.grey850',
    fontWeight: 700,
    minWidth: 90,
  },
  detailValue: {
    color: 'common.grey800',
  },
  note: {
    fontSize: 14,
    fontWeight: 500,
    marginTop: 2,
    textAlign: 'center',
  },
  successMessage: {
    color: 'common.grey800',
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-around',
    marginX: '40px',
    marginTop: 3,
  },
  button: {
    paddingX: 2,
    width: 130,
  },
  secondaryButton: {
    color: 'common.grey850',
  },
};

export default classes;
